import './styles/main.scss'
import './menu'
import './tabs'

import './icons'

import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import countries from './countries.json'
import axios from 'axios'

// init Swiper:
const swiper = new Swiper('.swiper', {
  modules: [Navigation, Pagination],
  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  
})

const autoswiper = new Swiper('.swiper-auto', {
  modules: [Navigation, Pagination, Autoplay],
  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
})


// SWIPER PRODUCT
const swiperProduct = new Swiper('.swiper-product', {
  slidesPerView: 1,
  spaceBetween: 36,
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
  },
  on: {
    init: function (elt) {
      // do something
      swiperProductInit(elt)
    },
    breakpoint: function(elt) {
      swiperProductInit(elt)
    }
  }
})

// window.
function swiperProductInit(elt) {
  const { activeIndex, slides, params: { slidesPerView }, el} = elt

  if (slides.length <= slidesPerView) {
    if(el.querySelector('.swiper-button-next')) el.querySelector('.swiper-button-next').style.display = 'none';
    if(el.querySelector('.swiper-button-prev')) el.querySelector('.swiper-button-prev').style.display = 'none';
    if(el.querySelector('.swiper-pagination')) el.querySelector('.swiper-pagination').style.display = 'none';
  } else {
    if(el.querySelector('.swiper-button-next') && window.innerWidth > 768) el.querySelector('.swiper-button-next').style.display = 'block';
    if(el.querySelector('.swiper-button-prev') && window.innerWidth > 768) el.querySelector('.swiper-button-prev').style.display = 'block';
    if(window.innerWidth < 768 && el.querySelector('.swiper-pagination')) el.querySelector('.swiper-pagination').style.display = 'flex';
  }

  slides.forEach((item, index) => {
    switch (slidesPerView) {
      case 3:
        if (activeIndex == index || activeIndex + 1 == index || activeIndex + 2 == index ) {
          item.classList.add('is-appear')
        } else {
          item.classList.remove('is-appear')
        }
        break;
      case 2: 
        if (activeIndex == index || activeIndex + 1 == index ) {
          item.classList.add('is-appear')
        } else {
          item.classList.remove('is-appear')
        }
        break;
      default:
        if (activeIndex == index) {
          item.classList.add('is-appear')
        } else {
          item.classList.remove('is-appear')
        }
        break;
    }
  })
}

swiperProduct.on('slideChange', (elt) => {
  swiperProductInit(elt)  
})

// SWIPER News
const swiperNews = new Swiper('.swiper-news', {
  slidesPerView: 1,
  spaceBetween: 48,
  modules: [Pagination],
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
  },
})

const swiperQuote = new Swiper('.swiper-quote', {
  slidesPerView: 1,
  spaceBetween: 0,
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 68,
    },
    1440: {
      slidesPerView: 1,
      spaceBetween: 148,
    },
  },
})

const swiperPartner = new Swiper('.swiper-partner', {
  slidesPerView: 'auto',
  spaceBetween: 24,
  loop: true,
  modules: [Navigation],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
})

const swiperEvent = new Swiper('.event-slider', {
  slidesPerView: 1,
  spaceBetween: 24,
  loop: true,
  modules: [Navigation, Pagination],
  pagination: {
    el: ".swiper-event-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-event-next",
    prevEl: ".swiper-event-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 84,
    },
  },
  on: {
    init: function (elt) {
      // do something
      swiperProductInit(elt)
    },
    breakpoint: function(elt) {
      swiperProductInit(elt)
    }
  }
})

const swiperPast = new Swiper('.past-slider', {
  slidesPerView: 1,
  spaceBetween: 24,
  loop: true,
  modules: [Navigation, Pagination],
  pagination: {
    el: ".swiper-past-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-past-next",
    prevEl: ".swiper-past-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 84,
    },
  },
  on: {
    init: function (elt) {
      // do something
      swiperProductInit(elt)
    },
    breakpoint: function(elt) {
      swiperProductInit(elt)
    }
  }
})


swiperEvent.on('slideChange', (elt) => {
  swiperProductInit(elt)  
})
swiperPast.on('slideChange', (elt) => {
  swiperProductInit(elt)  
})


const swiperVideo = new Swiper('.swiper-video', {
  slidesPerView: 1,
  spaceBetween: 24,
  loop: true,
  modules: [Navigation, Pagination],
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
  on: {
    init: function (elt) {
      // do something
      swiperProductInit(elt)
    },
    breakpoint: function(elt) {
      swiperProductInit(elt)
    }
  }
})

swiperVideo.on('slideChange', (elt) => {
  swiperProductInit(elt)  
})

// COMMENT
const btnComment = document.querySelector('[js-comment-btn]')
const comment = document.querySelector('[js-comment]')

if (btnComment) {
  btnComment.addEventListener('click', () => {
    comment.style.height = `${comment.scrollHeight}px`
    comment.querySelector('.comment-section-inner').style.opacity = 1
  })
}

const btnVideo = document.querySelectorAll('.js-video-play')
const coverVideo = document.querySelectorAll('.js-video-cover')
const iframeVideo = document.querySelectorAll('.js-video-iframe')

if (iframeVideo.length > 0) {
  btnVideo.forEach((item, index) => {
    item.addEventListener('click', () => {
      iframeVideo[index].style.opacity = 1
      iframeVideo[index].style.zIndex = 12
      coverVideo[index].style.opacity = 0
      item.style.display = 'none'

      iframeVideo[index].querySelector('iframe').src = `${iframeVideo[index].querySelector('iframe').src}?autoplay=1`
    })
 
  });
}



// JS MODAL 
const partnerItems = document.querySelectorAll('.js-modal-partner')
const partnerModales = document.querySelectorAll('.js-modal')
const partnerClose = document.querySelectorAll('.js-modal-close')

if (partnerItems.length > 0) {
  partnerItems.forEach((item, index) => {

    item.addEventListener('click', () => {
      document.querySelector('header').style.zIndex = 1
      partnerModales[index].style.display = 'flex'
      setTimeout(() => {
        partnerModales[index].classList.add('is-open')
      }, 50)
    })
  })

  partnerClose.forEach((item, index) => {
    item.addEventListener('click', () => {
      partnerModales[index].classList.remove('is-open')

      setTimeout(() => {
        partnerModales[index].style.display = 'none'
        document.querySelector('header').style = ''
      }, 300)
    })
  })
}


// COUNTRY

const countryList = document.querySelector('.contact-form-country-list')
const countryForm = document.querySelector('.contact-form-country input')
const cityForm = document.querySelector('.contact-form-city input')
const cpForm = document.querySelector('.contact-form-cp input')

if (countryList) {
  initCountries(countries)
}

if (countryForm) {
  countryForm.addEventListener('keyup', (e) => {
    if (countryForm.value.length >= 2) {
      const countriesName =  Object.keys(countries).filter((code) => countries[code].toLowerCase().includes(countryForm.value.toLowerCase()))
     
      let li = ''

        for (const code of countriesName) {
          li += `<li>${countries[code]}</li>`
        }

        countryList.innerHTML = li

        const items = countryList.querySelectorAll('li')
        for (const item of items) {
          item.addEventListener('click', () => {
            countryForm.value = item.textContent
            countryList.style.opacity = 0
            countryList.style.maxHeight = 0;
            // cityForm.disabled = item.textContent === 'France'
            // if(item.textContent === 'France') cityForm.parentElement.parentElement.classList.add('is-disabled')
            // else cityForm.parentElement.parentElement.classList.remove('is-disabled')
          })
        }
      
      countryList.style.opacity = 1
      countryList.style.maxHeight = '200px';
    } else {
      countryList.style.opacity = 0
      countryList.style.maxHeight = 0;
      initCountries(countries)
    }
  })

  // countryForm.addEventListener('change', (e) => {
  //   cpForm.disabled = countryForm.value === ''
  //   if(countryForm.value === '') cpForm.parentElement.parentElement.classList.add('is-disabled')
  //   else cpForm.parentElement.parentElement.classList.remove('is-disabled')
    
  //   if (countryForm.value === '') {
  //     cityForm.disabled = true
  //     cityForm.parentElement.parentElement.classList.add('is-disabled')
  //   }
  // })
}

if (cpForm) {
  // cpForm.disabled = true
  // cityForm.disabled = true
  // cpForm.parentElement.parentElement.classList.add('is-disabled')
  // cityForm.parentElement.parentElement.classList.add('is-disabled')

  cpForm.addEventListener('keyup', async () => {    
    if (countryForm.value === 'France' && cpForm.value.length === 5) {
      const res = await axios.get(`https://geo.api.gouv.fr/communes?codePostal=${cpForm.value}`) 
      if (res) {
        const { data } = res
        cityForm.value = data[0].nom
        
      }
    } else {

    }
  })
}


function initCountries(data) {
  let li = ''

  for (const code of Object.keys(data)) {
    li += `<li>${data[code]}</li>`
  }

  countryList.innerHTML = li

  const items = countryList.querySelectorAll('li')
  for (const item of items) {
    item.addEventListener('click', () => {
      countryForm.value = item.textContent
      countryList.style.opacity = 0
      countryList.style.maxHeight = 0;
    })
  }
}